// @flow

import * as React from "react";
import HistoricalErrorPlot from "./HistoricalErrorPlot";

const tasks = [
  {
    question:
      "Percentage of population using the internet in South Korea as of 2016 < 85",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf0ob3g1n0120xfzj9nfy",
    results: [
      {
        confidence: 50,
        id: "cjdgdtvl7vdrp0113ltrdt45t",
        createdAt: new Date("2018-02-06T02:09:10.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdgdtvrlv77v01724vb4qc0b",
        createdAt: new Date("2018-02-06T02:09:10.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdgdtvlhv77p0172clg3905p",
        createdAt: new Date("2018-02-06T02:09:10.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question: "number of seconds in a minute < 37",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf0x93gh10142i0cfmgce",
    results: [
      {
        confidence: 55,
        id: "cjdgkcfw501uz0179q594eriy",
        createdAt: new Date("2018-02-06T02:09:11.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 55,
        id: "cjdgkcfvjzdhw0177mrpd3uk9",
        createdAt: new Date("2018-02-06T02:09:11.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 55,
        id: "cjdgkcfw9zc9k0172vqdhziuc",
        createdAt: new Date("2018-02-06T02:09:11.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question:
      "Number of computer and information research scientists in USA in 2016 + the side length of a square with an area of one hundred units < 39,200",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf0xc3gh30142dszvlc4b",
    results: [
      {
        confidence: 45,
        id: "cjdgdrqu1vv1u017982sx8c3y",
        createdAt: new Date("2018-02-06T02:09:12.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdgdrr0sv5r00102g3p7tv69",
        createdAt: new Date("2018-02-06T02:09:12.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdgdrqu5vcec0113j6qu3b8o",
        createdAt: new Date("2018-02-06T02:09:12.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question:
      "gestation time in days of Hippopotamus + the number of red even-numbered cards in a pack of cards < 235",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf0zk3hjy0164pzvh578r",
    results: [
      {
        confidence: 50,
        id: "cjdgkb8ufzcsa0177bhtaolzu",
        createdAt: new Date("2018-02-06T02:09:13.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdgkb8udzcs80177m561ngbn",
        createdAt: new Date("2018-02-06T02:09:13.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdgkb8v6016001797p42539r",
        createdAt: new Date("2018-02-06T02:09:13.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question: "9 - value of 2 nickels in cents < -895",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf1653fpd0163bsc5ypp6",
    results: [
      {
        confidence: 55,
        id: "cjdgkrq6r0b150179grjc8oif",
        createdAt: new Date("2018-02-06T02:09:14.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdgkrq6uzyp10136z5g3p51u",
        createdAt: new Date("2018-02-06T02:09:14.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 55,
        id: "cjdgkrq79zkzy0102gdxtj88c",
        createdAt: new Date("2018-02-06T02:09:14.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question:
      "smaller angle between hour and minute hands at 6:22 in degrees < 145",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf1at3hk30164xvwv9qdg",
    results: [
      {
        confidence: 65,
        id: "cjdgoimit2nh90179qes9dqj7",
        createdAt: new Date("2018-02-06T02:09:15.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 55,
        id: "cjdgoimiu24f9011379hvau66",
        createdAt: new Date("2018-02-06T02:09:15.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdgoimiu1y6x0172z3703nrw",
        createdAt: new Date("2018-02-06T02:09:15.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question: "career steals by Kobe Bryant * 95 < 25,300",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnf1gf3g1x012049xnj7be",
    results: [
      {
        confidence: 50,
        id: "cjdgkeawozqe30136ts80gnl5",
        createdAt: new Date("2018-02-06T02:09:16.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdgkefq5zeib0177f93ep3hh",
        createdAt: new Date("2018-02-06T02:09:16.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdgkeawnzjzn0113ad28mna5",
        createdAt: new Date("2018-02-06T02:09:16.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question: "driving distance in miles between London and Milan < 394",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnffb33m5e0195h830w7kx",
    results: [
      {
        confidence: 50,
        id: "cjdam8qto3lk60179qm9c08g1",
        createdAt: new Date("2018-02-06T02:09:17.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 30,
        id: "cjdam8qtp3mw00159bbx9uq67",
        createdAt: new Date("2018-02-06T02:09:17.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 60,
        id: "cjdam8qtb3k3p0172k26q2o44",
        createdAt: new Date("2018-02-06T02:09:17.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question:
      "Price of the domain name Insurance.com in USD * the side length of a square with an area of four units < 167,000,000",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnfg133hoi0164peg2txcj",
    results: [
      {
        confidence: 40,
        id: "cjdam7gap3ff90102uyz7xjm9",
        createdAt: new Date("2018-02-06T02:09:18.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdam7gb83byo0113nfj0ti04",
        createdAt: new Date("2018-02-06T02:09:18.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 65,
        id: "cjdam7gj53jup0136e859ist0",
        createdAt: new Date("2018-02-06T02:09:18.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question: "minutes in one half of an NCAA basketball game < 10",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnfg6w3ko001481a7rpkop",
    results: [
      {
        confidence: 60,
        id: "cjdam6t0y3me701594asv6ayr",
        createdAt: new Date("2018-02-06T02:09:19.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdam6sxq3me20159o93g8o0y",
        createdAt: new Date("2018-02-06T02:09:19.000Z"),
        kind: "timeout",
        secondsLimit: 75,
        secondsElapsed: 75
      }
    ],
    answer: false
  },
  {
    question:
      "(number of countries that border Turkey * weight of $20 worth of quarters in pounds - Length of the Nile river in miles) - the largest odd number smaller than fifty < -3,810",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnflsi3go60142qlvexxt6",
    results: [
      {
        confidence: 70,
        id: "cjdgm7x2l0jzm0102vxz1twpq",
        createdAt: new Date("2018-02-06T02:09:20.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 55,
        id: "cjdgm7x790r5y0113fc5zjbum",
        createdAt: new Date("2018-02-06T02:09:20.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdgm7wxk1a0x0179a04qz4mc",
        createdAt: new Date("2018-02-06T02:09:20.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question:
      "cost of building 53W53 (MoMA expansion tower) in USD * 179 < 3,370,000,000,000",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctnfm2r3m7c0195xbpm9gn1",
    results: [
      {
        confidence: 50,
        id: "cjdgm7taq19xm0179x3tniq2f",
        createdAt: new Date("2018-02-06T02:09:21.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 70,
        id: "cjdgm7tav19xs0179ij8l54uh",
        createdAt: new Date("2018-02-06T02:09:21.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 55,
        id: "cjdgm7t290xl10136r4uasp4m",
        createdAt: new Date("2018-02-06T02:09:21.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question:
      "26 * (gestation time in days of Rat * world record in shot put by Randy Barnes rounded to nearest meter) + 67 < 2,100",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctng0ii3mdi0195dbr7l2qb",
    results: [
      {
        confidence: 65,
        id: "cjdb0c0gl97360179o45zmm5l",
        createdAt: new Date("2018-02-06T02:09:22.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 70,
        id: "cjdb0c0hx922v0113lmh3z03f",
        createdAt: new Date("2018-02-06T02:09:22.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 40,
        id: "cjdb0c0cs99i50172gubqshk8",
        createdAt: new Date("2018-02-06T02:09:22.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question:
      "smaller angle between hour and minute hands at 6:08 in degrees + (114 * atomic number of Uranium * age of oldest known living animal) < 1,750,000",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctngald3gyo01429ligqpnn",
    results: [
      {
        confidence: 50,
        id: "cjdaxd3vc8iwf0159w0prfrv5",
        createdAt: new Date("2018-02-06T02:09:23.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdaxd3uy894n0136mqd52eky",
        createdAt: new Date("2018-02-06T02:09:23.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 20,
        id: "cjdaxd3sw823n01137m3f7lol",
        createdAt: new Date("2018-02-06T02:09:23.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question:
      "Number of words in Atlas Shrugged by Ayn Rand - Bounty on Ayman al-Zawahiri, head of Al Qaeda, as at 2017 in USD < -2,570,000",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctngax83k9f0150bgpv1xig",
    results: [
      {
        confidence: 55,
        id: "cjdaosq2j4am00102slsn0pqs",
        createdAt: new Date("2018-02-06T02:09:24.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 55,
        id: "cjdaosq2g493j0113h7pj9yc3",
        createdAt: new Date("2018-02-06T02:09:24.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 50,
        id: "cjdaosq174epn0136vamuarj0",
        createdAt: new Date("2018-02-06T02:09:24.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question:
      "Population of Santiago * career rebounds by Karl Malone < 254,000,000,000",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctngdtv3mkp01955vu9l7fl",
    results: [
      {
        confidence: 50,
        id: "cjdgktfbtzub60113ntg7y5y1",
        createdAt: new Date("2018-02-06T02:09:25.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdgktfbrzn7001028z8i8vhu",
        createdAt: new Date("2018-02-06T02:09:25.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 20,
        id: "cjdgktfbd0lax0159gcd2yfgn",
        createdAt: new Date("2018-02-06T02:09:25.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: true
  },
  {
    question:
      "perimeter of a square with side length two * height of Harry Styles in inches < 350",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctngjq73kci0150zvk5guip",
    results: [
      {
        confidence: 55,
        id: "cjdgcu4pmuwv6013631b310y3",
        createdAt: new Date("2018-02-06T02:09:26.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 55,
        id: "cjdgcu4kvvh5e0159sn7jhn66",
        createdAt: new Date("2018-02-06T02:09:26.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 55,
        id: "cjdgcu4l4ul9m0177p0mgfjzx",
        createdAt: new Date("2018-02-06T02:09:26.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  },
  {
    question:
      "value of 2 nickels in cents * value of 2 quarters, 1 dime, and 1 penny in cents * number of teams in the English Premier League < 7,800",
    responseTimesInSeconds: [15, 75, 240],
    id: "cjctngodc3i540164nacak7n8",
    results: [
      {
        confidence: 35,
        id: "cjdb0c3s28x1a0177plmn33c2",
        createdAt: new Date("2018-02-06T02:09:27.000Z"),
        kind: "response",
        secondsLimit: 15,
        secondsElapsed: 15
      },
      {
        confidence: 50,
        id: "cjdb0c3tp8x1f0177p1bjiiwj",
        createdAt: new Date("2018-02-06T02:09:27.000Z"),
        kind: "response",
        secondsLimit: 75,
        secondsElapsed: 75
      },
      {
        confidence: 10,
        id: "cjdb0c3mg99it0172uf8fn3jd",
        createdAt: new Date("2018-02-06T02:09:27.000Z"),
        kind: "response",
        secondsLimit: 240,
        secondsElapsed: 240
      }
    ],
    answer: false
  }
];

const ExampleHistoricalErrorPlot = () => {
  return <HistoricalErrorPlot tasks={tasks} />;
};

export default ExampleHistoricalErrorPlot;



// WEBPACK FOOTER //
// ./src/components/HistoricalErrorPlot/Example.js